import { render, staticRenderFns } from "./cmpconsultarpedidos.vue?vue&type=template&id=60e011b8&"
import script from "./cmpconsultarpedidos.vue?vue&type=script&lang=js&"
export * from "./cmpconsultarpedidos.vue?vue&type=script&lang=js&"
import style0 from "./cmpconsultarpedidos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports